// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/cjs.js!./style.common.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Core Palette */
  --color-background-light: white;
  --color-border-dark: #0f1928;
  /* Value from style.common.css */

  /* Functional Colors (via filter) */
  --filter-icon-blue: hue-rotate(163deg) brightness(0.7) saturate(4);
  --filter-icon-blue-hover: hue-rotate(163deg) brightness(0.85) saturate(4);
  --filter-icon-error-hover: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(120%) contrast(86%);

  /* Text Colors */
  --color-text-light: #f5f5f5;
  --color-text-accent: var(--color-dark-text-accent);
  /* from style.common.css */

  /* Sizing & Spacing */
  --spacing-none: 0px;
  --spacing-xs: 3px;
  --spacing-s: 6px;
  --spacing-m: 10px;
  --spacing-xl: 20px;

  /* Borders */
  --border-radius-m: 5px;
  --border-width-l: 10px;
  --border-width-m: 5px;
  --border-style-default: solid;
}


/* File-specific CSS rules */

.top-menu-icons__blue-img,
.bmenu-item:not(.bmenu-item-disabled, .bmenu-item-selected, .bmenu-item-help) .bmenu-item-inner *,
.bmenu-filter-item:not(.bmenu-item-disabled, .bmenu-item-selected, .bmenu-item-help) .bmenu-filter-item-inner * {
  filter: var(--filter-icon-blue);
}

.top-menu-icons__blue-img:hover {
  filter: var(--filter-icon-blue-hover);
}

.top-menu-icons.bmenu-item-selected .bmenu-item-error:hover img {
  filter: var(--filter-icon-error-hover);
}

.top-menu-icons__blue-img:active *,
.top-menu-icons.bmenu-item-selected .bmenu-item-error:active *,
.bmenu-item .bmenu-item-inner:active *,
.bmenu-filter-item .bmenu-filter-item-inner:active * {
  scale: 0.9;
}

#colorbox-container {
  background-color: var(--color-background-light);
  transform: translateX(-200%);
  transition: transform 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  display: block;
  z-index: 100;
  width: 95%;
  height: 95%;
  margin: var(--spacing-none);
  border-color: var(--color-dark-border);
  border-width: var(--border-width-l);
  border-style: var(--border-style-default);
  border-radius: var(--border-radius-m);
}

.top-menu-icons {
  padding: var(--spacing-none);
  height: 100%;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./public/css/style.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;;EAEhC,mCAAmC;EACnC,kEAAkE;EAClE,yEAAyE;EACzE,oHAAoH;;EAEpH,gBAAgB;EAChB,2BAA2B;EAC3B,kDAAkD;EAClD,0BAA0B;;EAE1B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;EAElB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;AAC/B;;;AAGA,4BAA4B;;AAE5B;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,kFAAkF;EAClF,cAAc;EACd,YAAY;EACZ,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["@import url('style.common.css');\n\n:root {\n  /* Core Palette */\n  --color-background-light: white;\n  --color-border-dark: #0f1928;\n  /* Value from style.common.css */\n\n  /* Functional Colors (via filter) */\n  --filter-icon-blue: hue-rotate(163deg) brightness(0.7) saturate(4);\n  --filter-icon-blue-hover: hue-rotate(163deg) brightness(0.85) saturate(4);\n  --filter-icon-error-hover: invert(52%) sepia(130%) saturate(7323%) hue-rotate(353deg) brightness(120%) contrast(86%);\n\n  /* Text Colors */\n  --color-text-light: #f5f5f5;\n  --color-text-accent: var(--color-dark-text-accent);\n  /* from style.common.css */\n\n  /* Sizing & Spacing */\n  --spacing-none: 0px;\n  --spacing-xs: 3px;\n  --spacing-s: 6px;\n  --spacing-m: 10px;\n  --spacing-xl: 20px;\n\n  /* Borders */\n  --border-radius-m: 5px;\n  --border-width-l: 10px;\n  --border-width-m: 5px;\n  --border-style-default: solid;\n}\n\n\n/* File-specific CSS rules */\n\n.top-menu-icons__blue-img,\n.bmenu-item:not(.bmenu-item-disabled, .bmenu-item-selected, .bmenu-item-help) .bmenu-item-inner *,\n.bmenu-filter-item:not(.bmenu-item-disabled, .bmenu-item-selected, .bmenu-item-help) .bmenu-filter-item-inner * {\n  filter: var(--filter-icon-blue);\n}\n\n.top-menu-icons__blue-img:hover {\n  filter: var(--filter-icon-blue-hover);\n}\n\n.top-menu-icons.bmenu-item-selected .bmenu-item-error:hover img {\n  filter: var(--filter-icon-error-hover);\n}\n\n.top-menu-icons__blue-img:active *,\n.top-menu-icons.bmenu-item-selected .bmenu-item-error:active *,\n.bmenu-item .bmenu-item-inner:active *,\n.bmenu-filter-item .bmenu-filter-item-inner:active * {\n  scale: 0.9;\n}\n\n#colorbox-container {\n  background-color: var(--color-background-light);\n  transform: translateX(-200%);\n  transition: transform 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  display: block;\n  z-index: 100;\n  width: 95%;\n  height: 95%;\n  margin: var(--spacing-none);\n  border-color: var(--color-dark-border);\n  border-width: var(--border-width-l);\n  border-style: var(--border-style-default);\n  border-radius: var(--border-radius-m);\n}\n\n.top-menu-icons {\n  padding: var(--spacing-none);\n  height: 100%;\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
